import React from 'react'
import './css/Spinner.scss'

function Spinner() {
    return (
        <span className="loader"></span>
    )
}

export default Spinner